module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box-news-video",
    on: {
      "click": function($event) {
        _vm.window.open(_vm.newsData.newsContentURL)
      }
    }
  }, [_c('div', {
    staticClass: "title"
  }, [_c('div', {
    staticClass: "content"
  }, [_vm._v(_vm._s(_vm.newsData.newsContentTitle))])]), _vm._v(" "), _c('div', {
    staticClass: "video-box"
  }, [_c('video', {
    attrs: {
      "poster": _vm.newsData.newsContentImage,
      "src": _vm.newsData.newsContentURL,
      "preload": "none",
      "controls": "controls"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "info-box"
  }, [(_vm.isAd) ? _c('span', {
    staticClass: "ad-info"
  }, [_vm._v("广告")]) : _vm._e(), _vm._v(" "), _c('span', {
    staticClass: "source-box"
  }, [_vm._v(_vm._s(_vm.newsData.newsContentSource))]), _vm._v(" "), _c('span', {
    staticClass: "createTime-box"
  }, [_vm._v(_vm._s(_vm.newsData.newsContentUpdateTime))])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?{"id":"data-v-4e7aa072"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/content/business/newsTemplate/Video.vue
// module id = 763
// module chunks = 1